import { jsx as _jsx } from "react/jsx-runtime";
import { RouterManager } from "./modules/router/RouterManager";
export const App = () => {
    return _jsx(RouterManager, {});
};
